import React from "react";
import { ArrowRight } from "lucide-react";
import { whyUs, images } from "../mock";

const WhyUs = () => {
  return (
    <section
      id="why-us"
      className="relative py-20 md:py-28 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
        <img
          src={images.negotiation}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-[#E11D26]" />
            <span className="text-[#E11D26] text-xs sm:text-sm font-bold tracking-[0.25em] uppercase">
              Why Claim Beast
            </span>
          </div>
          <h2
            className="text-white text-4xl sm:text-5xl md:text-6xl font-black uppercase leading-[0.95]"
            style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
          >
            We Don't Play <span className="text-[#E11D26]">Nice</span> With Insurers.
          </h2>
          <p className="mt-6 text-white/75 leading-relaxed">
            Insurance adjusters work for the insurance company. Their job is to
            pay you as little as possible. We exist to flip that equation. We
            are your documentation team, your negotiator, your relentless
            advocate across the Tampa Bay area.
          </p>
          <a
            href="#contact"
            className="mt-8 inline-flex items-center justify-between gap-6 bg-[#E11D26] hover:bg-[#c11820] text-white font-bold uppercase tracking-wider px-7 py-4 transition-colors group"
          >
            <span className="text-sm underline underline-offset-4">
              Get a Free Claim Review
            </span>
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </a>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {whyUs.map((item) => (
            <div
              key={item.number}
              className="bg-[#0F0F0F] p-7 hover:bg-[#171717] transition-colors"
            >
              <div
                className="text-5xl font-black text-[#E11D26] leading-none"
                style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
              >
                {item.number}
              </div>
              <h3
                className="mt-4 text-white text-lg font-black uppercase tracking-wide"
                style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
              >
                {item.title}
              </h3>
              <p className="mt-3 text-white/65 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
